<marv-item (click)="this.selectOperation()" [class.with_remaining_days]="this.displayRemainingDays && this.operation.daysBeforePlanningClosing !== null">
    <div class="content_item"
         [class.enable_select_operation]="this.enableSelectOperation">
        <div class="operation_item">   
            <div class="operation_content_left">
                <div class="operation_content">
                    <app-operation-logo [operation]="this.getOperationLogo()" size="big"/>
                    <div class="operation_infos">
                        <ion-label>
                            {{this.operation.name}}         
                            @if(this.displayRemainingDays && !this.operation.isPlanningOpened && this.operation.daysBeforePlanningOpening !== null){
                                <app-operation-days-remaining [nbDaysRemaining]="this.operation.daysBeforePlanningOpening" typeDaysRemaining="open"/>
                            }
                            @else if(this.displayRemainingDays && this.operation.isPlanningOpened && this.operation.daysBeforePlanningClosing !== null){
                                <app-operation-days-remaining [nbDaysRemaining]="this.operation.daysBeforePlanningClosing" typeDaysRemaining="close"/>
                            }            
                        </ion-label>
                        <div class="operation_item_type">
                            <marv-tag color="primary" size="small" [color]="this.missionTypeService.getColor(this.operation.type)">{{this.missionTypeService.getLabel(this.operation.type)}}</marv-tag>
                        </div>
                        @if(this.operation.startDateIntervention && this.operation.endDateIntervention){
                            <ion-note>
                                {{'INTERVENTION_PERIOD' | translate}} :  
                                {{'DU' | translate}} <span class="date_intervention">{{this.operation.startDateIntervention | epochToString }}</span>
                                 {{'AU' | translate}} <span class="date_intervention">{{this.operation.endDateIntervention | epochToString }}</span>
                            </ion-note>
                        }                    
                    </div>
                </div>

            </div>

            <div class="operation_content_right">

                @if(this.displayQuota && this.operation.quotaTotal !== null){
                    <div class="quotas">
                        <div class="quota_total">{{this.roundQuota(this.operation.quotaTotal)}}</div>
                        <div class="quota quota_realized">
                            <div class="quota_label">{{'CONSUMED' | translate}}</div>
                            <div class="quota_value">{{this.roundQuota(this.operation.quotaRealized)}}</div>
                        </div>
                        <div class="quota quota_planned">
                            <div class="quota_label">{{'PLANNED_TO_COME' | translate}}</div>
                            <div class="quota_value">{{this.roundQuota(this.operation.quotaPlanned)}}</div>
                        </div>
                        <div class="quota quota_remaining">
                            <div class="quota_label">{{'BALANCE' | translate}}</div>
                            <div class="quota_value">{{this.roundQuota(this.operation.quotaRemaining)}}</div>
                        </div>
                    </div>
                }

                @if(this.displayNbMissionsPlanned){
                    <marv-circle class="nb_missions_planned">{{this.operation.plannedActivitiesCount}}</marv-circle>       
                }
            </div>  
        </div>    
  
        @if(this.displayBtnAddIntervention && this.isLoggedUserAllowedToPlan){
            <marv-button class="btn_add_intervention" icon="add-outline" [rounded]="true" [disabled]="this.disabledBtnAddIntervention" (click)="this.addIntervention($event)"/>
        }
    
        @if(this.displayBtnRemoveOperation){
            <marv-button class="btn_remove_operation" icon="close-outline" [rounded]="true" color="red" [disabled]="this.disabledBtnRemoveOperation" (click)="this.removeOperation($event)"/>
        }
        
    </div>
</marv-item>